import { useLayoutEffect, useState, type RefObject } from 'react';

/** Clamp a desired cursor position to the viewport for a popover of unknown
 * size. Pass the open ref; after the menu measures we snap the position to
 * `viewport - menuSize - margin` if it would otherwise overflow. */
export function useClampedMenuPosition(
  ref: RefObject<HTMLElement | null>,
  desired: { x: number; y: number } | null,
  margin = 8,
) {
  const [pos, setPos] = useState<{ x: number; y: number } | null>(desired);

  useLayoutEffect(() => {
    if (!desired) { setPos(null); return; }
    const el = ref.current;
    if (!el) { setPos(desired); return; }
    const rect = el.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    let x = desired.x;
    let y = desired.y;
    if (x + rect.width + margin > vw)  x = Math.max(margin, vw - rect.width  - margin);
    if (y + rect.height + margin > vh) y = Math.max(margin, vh - rect.height - margin);
    setPos({ x, y });
  }, [ref, desired, margin]);

  return pos;
}
